import { Component, OnInit } from '@angular/core';
import { FirebaseTSFirestore, Limit, OrderBy, Where } from 'firebasets/firebasetsFirestore/firebaseTSFirestore';
import { FirebaseTSAuth } from 'firebasets/firebasetsAuth/firebaseTSAuth';
import { PostData } from 'src/app/models/post.model';
import { UserData } from 'src/app/models/user.model';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DeletePostDialogComponent } from 'src/app/delete-post-dialog/delete-post-dialog.component';
import { ImageModalComponent } from 'src/app/image-modal/image-modal.component';
import { AuthService } from 'src/app/services/auth.service';
import { SearchService } from 'src/app/search.service';
import { BottomBarService } from 'src/app/services/bottom-bar.service';
import { BreakpointObserver } from '@angular/cdk/layout';
import { UnreadMessagesService } from 'src/app/services/unread-messages.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FirebaseTSStorage } from 'firebasets/firebasetsStorage/firebaseTSStorage';
import { EditProfileDialogComponent } from 'src/app/edit-profile-dialog/edit-profile-dialog.component';
import { ChangeProfilePictureDialogComponent } from 'src/app/change-profile-picture-dialog/change-profile-picture-dialog.component';
import { ImageCropDialogComponent } from 'src/app/image-crop-dialog/image-crop-dialog.component';

@Component({
  selector: 'app-mon-profil',
  templateUrl: './mon-profil.component.html',
  styleUrls: ['./mon-profil.component.css']
})
export class MonProfilComponent implements OnInit{

  firestore = new FirebaseTSFirestore();
  userData: any;
  userPosts: any[] = [];
  followers: any[] = [];
  following: any[] = [];
  followersCount: number = 0;
  followingCount: number = 0;
  profilePhotoUrl: string = '';
  coverPhotoUrl: string = '';
  auth = new FirebaseTSAuth();
  storage = new FirebaseTSStorage();
  

  constructor(private dialog: MatDialog, private snackBar: MatSnackBar) {}
  ngOnInit(): void {
    this.loadUserProfile();
  }


  loadUserProfile() {
    const userId = this.getUserId(); // Assurez-vous de récupérer l'ID utilisateur correctement
    this.firestore.getDocument({
      path: ["Users", userId],
      onComplete: result => {
        this.userData = result.data();
        if(this.userData?.profilePhotoUrl == ""){
          this.profilePhotoUrl = "https://firebasestorage.googleapis.com/v0/b/lenali-21.appspot.com/o/profile2.png?alt=media&token=a24d9c4a-5daf-48c0-a265-88c4b0371f3c";
        }else{
          this.profilePhotoUrl = this.userData?.profilePhotoUrl;
        }

        if(this.userData?.coverPhotoUrl == ""){
          this.coverPhotoUrl = "https://firebasestorage.googleapis.com/v0/b/lenali-21.appspot.com/o/defaultCoverImage.jpg?alt=media&token=d509e05d-dd94-4ff3-b37f-24430c3a82bf";
        }else{
          this.coverPhotoUrl = this.userData?.coverPhotoUrl;
        }
        this.followers = this.userData?.followers || [];
        this.following = this.userData?.following || [];
        this.followersCount = this.followers.length;
        this.followingCount = this.following.length;
        
        this.loadUserPosts(userId);
      },
      onFail: err => {
        console.error(err);
      }
    });
  }

  loadUserPosts(userId: string) {
    
    return this.firestore.getCollection({
      path: ["Posts"],
      where: [
        new Where("creatorId", "==", userId),
        new Limit(50)
      ],
      onComplete: result => {
        
        result.docs.forEach(
          doc => {
            if(doc.data()?.creatorId == userId){
              let post = <PostData>doc.data();
              post.postId = doc.id;
              


              if (post.lenali && post.lenali === true ) {
                
                this.userPosts.push(post);
              }
              
            }else{
              
            }
            
          }
        );

        // Trier par ordre décroissant sur le champ 'timestamp'
        this.userPosts.sort((a, b) => {
          // Assurez-vous que 'timestamp' est un champ utilisable ici
          return b.timestamp - a.timestamp;
        });
      },

      
      onFail: err => {
        console.error(err);
        
      }
    });
  }

  getUserId(): string {
    // Remplacez cette méthode par la logique réelle pour obtenir l'ID de l'utilisateur connecté
    return this.auth.getAuth().currentUser.uid;;
  }

  onChangeProfilePicture() {
    //const file = event.target.files[0];
    
    const dialogRef = this.dialog.open(ChangeProfilePictureDialogComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Si une image est sélectionnée, mettre à jour la photo de profil
        this.uploadProfilePicture(result);
      } 
    }); 
  }

  uploadProfilePicture(image: string | ArrayBuffer) {
  // Convertir l'image en blob ou base64 pour l'envoyer à Firebase
  // Exemple de code pour uploader l'image sur Firebase Storage

  // Afficher un snack-bar de succès
  this.snackBar.open('Photo de profil modifiée avec succès!', 'Fermer', {
    duration: 3000,
  });
}
  

  onChangeCoverPhoto(event: any): void {
    const file = event.target.files[0];
    if (file) {
      const uploadMetadata: firebase.default.storage.UploadMetadata = {
        contentType: file.type // Type de contenu pour l'image (par exemple, 'image/jpeg')
      };
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.coverPhotoUrl = e.target.result;
        // Ouvrir le dialogue de recadrage ici, si nécessaire

        // Upload to Firebase Storage
        const userId = this.auth.getAuth().currentUser?.uid;
        if (userId) {
          const path = `Users/${userId}/cover_photo`;
          this.storage.upload(
            {
              uploadName: "Upload Cover Photo",
              path: [path],
              data: {
                data: file,
                metadata: { contentType: file.type }
              },
              onComplete: (downloadURL) => {
                // Handle successful upload and save the download URL in Firestore
                console.log("Cover photo uploaded!", downloadURL);
                this.coverPhotoUrl = downloadURL;
                this.firestore.update(
                  {
                    path: ["Users", userId],
                    data: {
                      coverPhotoUrl: downloadURL
                    }
                  }
                );
              },
              onFail: (error) => {
                console.error("Upload failed", error);
              }
            }
          );
        }
      };
      reader.readAsDataURL(file);
    }
  }
 

  onEditProfile() {
    const dialogRef = this.dialog.open(EditProfileDialogComponent, {
      data: {
        // Passez les données actuelles du profil ici
        publicName: this.userData?.publicName,
        profession: this.userData?.description,
        telephone: this.userData?.telephone || "",
        ville: this.userData?.ville || "",
        
        // Ajoutez d'autres champs de profil si nécessaire
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Met à jour les informations de profil sur Firestore
        this.firestore.update({
          path: ["Users", this.getUserId()],
          data: {
            publicName: result.publicName,
            telephone: result.telephone,
            description: result.profession,
            ville: result.ville
            // Ajoutez d'autres champs de profil mis à jour si nécessaire
          }
        });
      }
    });
  }

  openCropDialog(file: File, callback: (croppedImage: Blob) => void) {
    // Implémentez un dialogue de recadrage ici, puis appelez callback avec l'image recadrée
  }

  openConfirmationDialog(file: File, callback: (confirmed: boolean) => void) {
    // Implémentez un dialogue de confirmation ici, puis appelez callback avec la réponse de l'utilisateur
  }

  openEditProfileDialog(callback: (newProfileData: { firstName: string, lastName: string, profession: string }) => void) {
    // Implémentez un formulaire modale ici, puis appelez callback avec les nouvelles informations de l'utilisateur
  }

  changeProfilePhoto(event: any) {
    const dialogRef = this.dialog.open(ImageCropDialogComponent, {
      data: { imageEvent: event }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // Résultat contient l'image recadrée en base64
        this.uploadProfilePhoto(result);
      }
    });
  }

  uploadProfilePhoto(croppedImage: string) {
    // Logic to upload the cropped image to Firebase
  }
  
}
